import { useTranslation } from 'react-i18next'
import { paths } from 'routes/paths'
import Loader from 'components/ui/loader/Loader'
import { usePrerequisites } from '../../contexts/Prerequisites'
import styles from './style.module.scss'
import { WithCourses } from './WithCourses'
import { WithoutCourses } from './WithoutCourses'
import { LearningPathPrerequisites } from './LearningPathPrerequisites/index'

export const Prerequisites = () => {
  const { t } = useTranslation()
  const prefix = 'courses.show.content.prerequisites.byCourses'

  const { courses, isLoading, learningPaths } = usePrerequisites()

  const LearningPaths = (
    <>
      {learningPaths?.map((item, index) => {
        let conjunction = ''
        if (learningPaths.length > 1) {
          if (learningPaths.length === index + 1)
            conjunction = t(`${prefix}.description.conjunction`)
          else {
            if (index + 1 > 1) conjunction = ','
          }
        }
        return (
          <span key={index}>
            {conjunction}{' '}
            <a href={paths.learningPath.details(item.id)}>{item.name}</a>
          </span>
        )
      })}
    </>
  )

  if (isLoading) return <Loader color />

  if (learningPaths.length === 0) return null

  return (
    <div className={styles.wrapper}>
      <LearningPathPrerequisites />
      {courses.length > 0 ? (
        <WithCourses courses={courses} learningPaths={LearningPaths} />
      ) : (
        <WithoutCourses learningPaths={LearningPaths} />
      )}
    </div>
  )
}
